import React, { lazy, ComponentType } from "react";
import {
  dashboardPagesMenu,
  demoPagesMenu,
  adminDashboardMenu,
  authPages,
} from "../menu";
import LogoutUser from "../pages/logoutUser/LogoutUser";
import { RouteObject } from "react-router-dom";
import PaymentSuccess from "../pages/invoices/PaymentSuccess";
import GetEbuttonTransactions from "../pages/eButtonServices/GetEbuttonTransactionsSrvice";
import CustomerUpdateToken from "../pages/eButtons/CustomerUpdateToken";

// Lazy load all components
const lazyLoad = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) => lazy(factory);

const ADMIN = {
  //merchants
  UPDATESUBMERCHANT: lazyLoad(() => import("../pages/admin-pages/UpdateSubmerchant")),
  MERCHANTLIST: lazyLoad(() => import("../pages/admin-pages/MerchantsList")),
  UPLOADCSV: lazyLoad(() => import("../pages/admin-pages/UploadCsv")),
  CREATEMERCHANT: lazyLoad(() => import("../pages/admin-pages/MerchantCreate")),
  UPDATEMERCHANT: lazyLoad(() => import("../pages/admin-pages/UpdateMerchant")),
  //customers
  UPLOADCUTOMER: lazyLoad(() => import("../pages/customer-pages/UploadCustomers")),
  CUSTOMEREMAIL: lazyLoad(() => import("../pages/customer-pages/CustomerEmail")),
  CUSTOMERSLIST: lazyLoad(() => import("../pages/customer-pages/CustomersList")),
  CREATECUSTOMERS: lazyLoad(() => import("../pages/customer-pages/CreateCustomer")),
  UPDATECUSTOMERS: lazyLoad(() => import("../pages/customer-pages/CustomersUpdate")),
  //invoices
  INVOICELIST: lazyLoad(() => import("../pages/invoices/InvoiceList")),
  RECURRINGLIST: lazyLoad(() => import("../pages/invoices/RecurringList")),
  ADDINVOICE: lazyLoad(() => import("../pages/invoices/CreateInvoice")),
  UPLOADINVOICES: lazyLoad(() => import("../pages/invoices/UploadInvoices")),
  UPDATEINVOICE: lazyLoad(() => import("../pages/invoices/UpdateInvoice")),
  CREATEINVOICEITEM: lazyLoad(() => import("../pages/invoices/CreateInvoiceItem")),
  UPDATEINVOICEITEM: lazyLoad(() => import("../pages/invoices/updateInvoiceItem")),
  PAYINVOICE: lazyLoad(() => import("../pages/invoices/customerPaymentForm")),
  PAYINVOICEBYMERCHANT: lazyLoad(() => import("../pages/invoices/MerchantPaymentForm")),
  PAYMENTSUCCESS: lazyLoad(() => import("../pages/invoices/PaymentSuccess")),
  //items
  ITEMSLIST: lazyLoad(() => import("../pages/items/ItemsList")),
  ADDIITEM: lazyLoad(() => import("../pages/items/CreateItem")),
  UPDATEIITEM: lazyLoad(() => import("../pages/items/UpdateItem")),
  SETTING: lazyLoad(() => import("../pages/settings/SettingPage")),
  UPLOADITEMS: lazyLoad(() => import("../pages/items/UploadItems")),
  PROFILE: lazyLoad(() => import("../pages/profile")),
  //super users
  CREATESUPERUSERS: lazyLoad(() => import("../pages/create admins/CreateSuperUsers")),
  UPDATESUPERUSERS: lazyLoad(() => import("../pages/create admins/UpdateSuperUser")),
  LOGOUT: lazyLoad(() => import("../pages/logoutUser/LogoutUser")),
  //ebuttons
  EBUTTONLIST: lazyLoad(() => import("../pages/eButtons/EbuttonList")),
  EBUTTONCREATE: lazyLoad(() => import("../pages/eButtons/create/CreateEbutton")),
  EBUTTONUPDATE: lazyLoad(() => import("../pages/eButtons/update/UpdateEbutton")),
  GENERATECODE: lazyLoad(() => import("../pages/eButtons/GenerateCode")),
  PAYMENTFORM: lazyLoad(() => import("../pages/eButtons/eButtonPaymentForm")),
   PAYMENTNOTFOUND: lazyLoad(() => import("../pages/eButtons/Page404")), 
  NOTFOUNDINVENTORY: lazyLoad(() => import("../pages/eButtons/NotFoundInventoryPage")),
  CustomerUpdateToken: lazyLoad(() => import("../pages/eButtons/CustomerUpdateToken")),
  //404 pge
  PAGE404:lazyLoad(() => import("../pages/invoices/page404")),
};

const LANDING = {
  DASHBOARD: lazyLoad(() => import("../pages/presentation/dashboard/DashboardPage")),
};

//Auth Page
const AUTH = {
  PAGE_404: lazyLoad(() => import("../pages/presentation/auth/Page404")),
  LOGIN: lazyLoad(() => import("../pages/auth/Login")),
  OTP: lazyLoad(() => import("../pages/auth/Otp")),
  FORGOTPASSWORD: lazyLoad(() => import("../pages/auth/ForgotPassword")),
  SETPASSWORD: lazyLoad(() => import("../pages/auth/SetPassword")),
};

const EBUTTONSERVICE = {
  EBUTTONSERVICE: lazyLoad(() => import("../pages/eButtonServices/eButtonServices")),
  CREATEEBUTTONSERVICE: lazyLoad(() => import("../pages/eButtonServices/CreateEbutonService")),
  CREATEEBUTTONSERVICERESPONSE: lazyLoad(() => import("../pages/eButtonServices/xmlResponse")),
  DELETEEBUTTONSERVICE: lazyLoad(() => import("../pages/eButtonServices/DeleteEbuttonService")),
  DELETEEBUTTONSERVICERESPONSE: lazyLoad(() => import("../pages/eButtonServices/xmlResponse")),
  EDITEBUTTONSERVICE: lazyLoad(() => import("../pages/eButtonServices/EditEbuttonService")),
  EDITEBUTTONSERVICERESPONSE: lazyLoad(() => import("../pages/eButtonServices/xmlResponse")),
  GETTRANSACTIONBYID: lazyLoad(() => import("../pages/eButtonServices/GetTransactionByIdService")),
  GETTRANSACTIONBYIDRESPONSE: lazyLoad(() => import("../pages/eButtonServices/xmlResponse")),
  GETTRANSACTIONBYREFERENCENUMBER: lazyLoad(() => import("../pages/eButtonServices/GetTransactionByReferenceNumberService")),
  GETTRANSACTIONBYREFERENCENUMBERRESPONSE: lazyLoad(() => import("../pages/eButtonServices/xmlResponse")),
  GETEBUTTONTRANSACTIONS: lazyLoad(() => import("../pages/eButtonServices/GetEbuttonTransactionsSrvice")),
  GETEBUTTONTRANSACTIONSRESPONSE: lazyLoad(() => import("../pages/eButtonServices/xmlResponse")),
  SERVICEDESCRIPTION: lazyLoad(() => import("../pages/eButtonServices/ServiceDescription")),
};

const adminpages: RouteObject[] = [
  //Merchants
  {
    path: adminDashboardMenu.merchants.path,
    element: <ADMIN.MERCHANTLIST />,
  },
  {
    path: "importmerchants",
    element: <ADMIN.UPLOADCSV />,
  },
  {
    path: "createmerchant",
    element: <ADMIN.CREATEMERCHANT />,
  },
  {
    path: "updatemerchant/:id",
    element: <ADMIN.UPDATEMERCHANT />,
  },
  {
    path: "updatesubmerchant/:id",
    element: <ADMIN.UPDATESUBMERCHANT />,
  },
  // customers 
  {
    path: adminDashboardMenu.customers.path,
    element: <ADMIN.CUSTOMERSLIST />,
  },
  {
    path: "createcustomer",
    element: <ADMIN.CREATECUSTOMERS />,
  },
  {
    path: "importcustomers",
    element: <ADMIN.UPLOADCUTOMER />,
  },
  {
    path: "emailcustomer/:id",
    element: <ADMIN.CUSTOMEREMAIL />,
  },
  {
    path: "updatecustomer/:id",
    element: <ADMIN.UPDATECUSTOMERS />,
  },
  // invoices
  {
    path: "invoices",
    element: <ADMIN.INVOICELIST />,
  },
  {
    path: "uploadinvoices",
    element: <ADMIN.UPLOADINVOICES />,
  },
  {
    path: "createinvoice",
    element: <ADMIN.ADDINVOICE />,
  },
  {
    path: "createinvoiceitem/:id",
    element: <ADMIN.CREATEINVOICEITEM />,
  },
  {
    path: "recurringlist",
    element: <ADMIN.RECURRINGLIST />,
  },

  {
    path: "updateinvoiceitem/:id",
    element: <ADMIN.UPDATEINVOICEITEM />,
  },
  {
    path: "updateinvoice/:id",
    element: <ADMIN.UPDATEINVOICE />,
  },
  {
    path: "payinvoice/:id",
    element: <ADMIN.PAYINVOICE />,
  }, {
    path: "paymentsuccess",
    element: <ADMIN.PAYMENTSUCCESS />,
  },
  {
    path: "payments/:id",
    element: <ADMIN.PAYINVOICEBYMERCHANT />,
  },
  //create Item
  {
    path: "createitem",
    element: <ADMIN.ADDIITEM />,
  },
  {
    path: "updateitem/:id",
    element: <ADMIN.UPDATEIITEM/>,
  },
  {
    path: "items",
    element: <ADMIN.ITEMSLIST />,
  },
  {
    path: "importitems",
    element: <ADMIN.UPLOADITEMS />,
  },
  //eButtons
  {
    path: "ebuttoncreate",
    element: <ADMIN.EBUTTONCREATE />,
  },
  {
    path: "ebuttonupdate/:id",
    element: <ADMIN.EBUTTONUPDATE />,
  },
  {
    path: "generatecode/:id",
    element: <ADMIN.GENERATECODE />,
  },
  {
    path: "ebuttons",
    element: <ADMIN.EBUTTONLIST />,
  },
  {
    path: "checkout",
    element: <ADMIN.PAYMENTFORM />,
  },
  {
     path: "paymentlinknotfound",
    element: <ADMIN.PAYMENTNOTFOUND />,
  },
  {
    path: "inventorynotfound",
    element: <ADMIN.NOTFOUNDINVENTORY />,
  },
  {
    path: "customerupdatetoken/:id",
    element: <ADMIN.CustomerUpdateToken />,
  },
  

  // eButton Service
  {
    path: "ebutton-docs",
    element: <EBUTTONSERVICE.EBUTTONSERVICE />,
  },
  {
    path: "ebutton-docs/CreateButton",
    element: <EBUTTONSERVICE.CREATEEBUTTONSERVICE />,
  },
  {
    path: "ebutton-docs/createbuttonresponse",
    element: <EBUTTONSERVICE.CREATEEBUTTONSERVICERESPONSE />,
  },
  {
    path: "ebutton-docs/DeleteButton",
    element: <EBUTTONSERVICE.DELETEEBUTTONSERVICE />,
  },
  {
    path: "ebutton-docs/deletebuttonresponse",
    element: <EBUTTONSERVICE.DELETEEBUTTONSERVICERESPONSE />,
  },
  {
    path: "ebutton-docs/EditButton",
    element: <EBUTTONSERVICE.EDITEBUTTONSERVICE />,
  },
  {
    path: "ebutton-docs/editbuttonresponse",
    element: <EBUTTONSERVICE.EDITEBUTTONSERVICERESPONSE />,
  },
  {
    path: "ebutton-docs/GetTransactionsByButtonId",
    element: <EBUTTONSERVICE.GETTRANSACTIONBYID />,
  },
  {
    path: "ebutton-docs/gettransactionsbybuttonidresponse",
    element: <EBUTTONSERVICE.GETTRANSACTIONBYIDRESPONSE />,
  },
  {
    path: "ebutton-docs/GetTransactionsByReferenceNumber",
    element: <EBUTTONSERVICE.GETTRANSACTIONBYREFERENCENUMBER />,
  },
  {
    path: "ebutton-docs/gettransactionsbyreferencenumberresponse",
    element: <EBUTTONSERVICE.GETTRANSACTIONBYREFERENCENUMBERRESPONSE />,
  },
  {
    path: "ebutton-docs/GetButtonTransactions",
    element: <EBUTTONSERVICE.GETEBUTTONTRANSACTIONS />,
  },
  {
    path: "ebutton-docs/getebuttontransactionsresponse",
    element: <EBUTTONSERVICE.GETEBUTTONTRANSACTIONSRESPONSE />,
  },

  {
    path: "ebutton-docs/servicedescription",
    element: <EBUTTONSERVICE.SERVICEDESCRIPTION />,
  },
  // settings
  {
    path: adminDashboardMenu.settings.path,
    element: <ADMIN.SETTING />,
  },
  {
    path: "profile",
    element: <ADMIN.PROFILE />,
  },
  {
    path: "createUser",
    element: <ADMIN.CREATESUPERUSERS />,
  },
  {
    path: "updateUser/:id",
    element: <ADMIN.UPDATESUPERUSERS />,
  },
  {
    path: adminDashboardMenu.logout.path,
    element: <LogoutUser />,
  },
  {
    path: "notfound",
    element: <ADMIN.PAGE404/>,
  },
  
];

const presentation: RouteObject[] = [
  /**
   * Landing
   */
  {
    path: dashboardPagesMenu.dashboard.path,
    element: <LANDING.DASHBOARD />,
  },
  
  /**
   * Auth Page
   */
  {
    path: demoPagesMenu.page404.path,
    element: <AUTH.PAGE_404 />,
  },
  {
    path: authPages.login.path,
    element: <AUTH.LOGIN />,
  },
  {
    path: authPages.otp.path,
    element: <AUTH.OTP />,
  },
  {
    path: authPages.forgotpassword.path,
    element: <AUTH.FORGOTPASSWORD />,
  },
  {
    path: authPages.setpassword.path,
    element: <AUTH.SETPASSWORD />,
  },
];

const contents: RouteObject[] = [...presentation, ...adminpages];

export default contents;